import { ReactNode, useCallback, useState } from 'react';

import { Alert } from '../components/Alert';

export interface AlertItem
  extends Pick<
    InferComponentProps<typeof Alert>,
    'type' | 'shouldShake' | 'layout' | 'actions'
  > {
  content: ReactNode;
  persist?: boolean;
}

const useAlerts = (
  initialAlerts: AlertItem[] = []
): {
  alerts: AlertItem[];
  addAlerts: (alerts: AlertItem[]) => void;
  clearAlerts: () => void;
} => {
  const [alerts, setAlerts] = useState<AlertItem[]>(initialAlerts);

  const addAlerts = useCallback(
    (alerts: AlertItem[]) => setAlerts((state) => [...state, ...alerts]),
    []
  );

  const clearAlerts = useCallback(
    () => setAlerts((state) => state.filter((alert) => alert.persist)),
    []
  );

  return { alerts, addAlerts, clearAlerts };
};

export default useAlerts;
